import React, {useEffect, useState} from 'react';
import TimePicker from "../../date-time-picker/timePicker/TimePicker";
import DatePicker from "../../date-time-picker/datePicker/DatePicker";
import './style.scss';

interface Props {
    time: Date | null,
    onChangeTime: (time: any) => void,
    title: string
}

const ExportDatePickerComponent : React.FC<Props> = ({time, onChangeTime, title}) => {
    const [dateLoc, setDateLoc] = useState<null | string>(null);
    const [timeLoc, setTimeLoc] = useState<null | string>(null);

    const setUpTime = (name: string, value: number) => {
        if (!time) return;
        try {
            switch(name) {
                case 'year': time.setFullYear(value);break;
                case 'month': time.setMonth(value - 1);break;
                case 'day': time.setDate(value);break;
                case 'hour12': time.setHours(value);break;
                case 'hour24': time.setHours(value);break;
                case 'hour': time.setHours(value);break;
                case 'minute': time.setMinutes(value);break;
                case 'second': time.setSeconds(value);break;
                default: {}
            }

            onChangeTime(new Date(time.valueOf()))
        } catch(e) {
            onChangeTime(new Date());
        }

    };

    const onChangeByTypingTime = (t: string) => {
        try {
            onChangeTime(new Date(dateLoc + ' ' + t));
        }
        catch(e) {
            onChangeTime(new Date());
        }
    };

    const onChangeByTypingDate = (date: Date) => {
        try {
            onChangeTime(new Date(date.toDateString() + ' ' + timeLoc));
        } catch(e) {
            onChangeTime(new Date());
        }
    };

    useEffect(() => {
        if (time) {
            setDateLoc(time.toDateString());
            setTimeLoc(time.toTimeString());
        }
    }, [time]);


    return (
        <>
        {
            time &&
                <div>
                    <h2 className='export-picker-title'>{title}</h2>
                    <div className='export-picker fade-in'>
                        <DatePicker
                            onChange={onChangeByTypingDate}
                            value={time}
                            calendarIcon={null}
                            clearIcon={null}
                            className={'date-picker'}
                            disableClock={true}
                            disableCalendar={true}
                            arrows={['year', 'month', 'day']}
                            increaseValue={setUpTime}
                            decreaseValue={setUpTime}
                        />

                        <TimePicker
                            onChange={onChangeByTypingTime}
                            value={time}
                            maxDetail={'second'}
                            calendarIcon={null}
                            clearIcon={null}
                            className={'date-picker'}
                            disableClock={true}
                            disableCalendar={true}
                            increaseValue={setUpTime}
                            decreaseValue={setUpTime}
                            // locale={'sv-sv'}  // uses for demonstrating 24 hours
                            arrows={['hour24', 'hour12', 'minute', 'second']}
                        />
                    </div>
                </div>
            }
        </>
    )
};

export default ExportDatePickerComponent